<template>
	<v-icon
		:size="size"
		:color="color"
	>
	{{icon}}
	</v-icon>
</template>

<script>
export default {
	props: {
		icon: String,
		color: String,
		size: [Number, String],
	},
}
</script>
